export default __webpack_public_path__ + "img/register_bg_2.4f2cb0ac.png";